
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M47.5 33.5c-3.6 0-6.7 2.9-6.7 6.7a6.7 6.7 0 0013.4 0c-.1-3.7-3.1-6.7-6.7-6.7zm32.9 0c-3.6 0-6.7 2.9-6.7 6.7 0 3.7 2.9 6.7 6.7 6.7s6.7-3 6.7-6.7-3-6.7-6.7-6.7zM41 52.4v42.1h9.2V65h.1l10 29.5h7.2l10.1-29.6v29.6h9.3V52.4H73.5l-9.3 28.9h-.1l-9.8-28.9H41zM0 60.2v-7.8h34.8v7.8H22v34.2h-9.3V60.2H0zM113.1 52.4c1.9 0 3.7.2 5.4.5 1.6.4 3 .9 4.1 1.7 1.1.8 2 1.9 2.6 3.2.6 1.3.9 3 .9 5 0 2.1-.5 3.9-1.4 5.3-.9 1.4-2.3 2.6-4.1 3.4 2.5.7 4.3 2 5.6 3.9 1.2 1.8 1.8 4.1 1.8 6.8 0 2.1-.4 3.9-1.2 5.6-.8 1.5-1.9 2.8-3.2 3.8-1.3 1-2.9 1.7-4.6 2.2-1.7.5-3.5.7-5.4.7H94V52.4h19.1zM112 69.5c1.6 0 2.9-.4 3.9-1.2s1.5-2 1.5-3.8c0-1-.2-1.8-.5-2.4-.3-.6-.8-1.1-1.4-1.5s-1.2-.6-2-.7c-.7-.1-1.5-.2-2.3-.2h-8.5v9.8h9.3zm.5 17.8c.9 0 1.7-.1 2.5-.3.8-.2 1.5-.5 2.1-.9s1.1-1 1.5-1.7.5-1.6.5-2.7c0-2.1-.6-3.7-1.8-4.6-1.2-.9-2.7-1.4-4.6-1.4h-9.8v11.6h9.6"}})])
          )
        }
      }
    